import { Fare } from "../../types/Fare";

export interface FareDisplayProps {
  fare?: Fare;
  showEffectiveFrom?: boolean;
  noFareMessage?: string;
}

const FareDisplay = ({
  fare,
  noFareMessage,
  showEffectiveFrom = false,
}: FareDisplayProps) => {
  const formatPrice = (price?: number) => {
    if (!price) return "-";
    return `£${price.toFixed(2)}`;
  };

  return (
    <>
      {!fare && (
        <p className="Text-Warning">{noFareMessage ?? "No Current Fare"}</p>
      )}
      {fare && (
        <>
          {showEffectiveFrom && (
            <p className="m-0">
              Effective from:{" "}
              {new Date(Date.parse(fare.effectiveFrom)).toLocaleString(
                "en-GB",
                {
                  dateStyle: "short",
                },
              )}
            </p>
          )}
          <table className="table table-striped table-sm">
            <thead>
              <tr>
                <th></th>
                <th className="text-center">Daily</th>
                <th className="text-center">Weekly</th>
                <th className="text-center">Monthly</th>
                <th className="text-center">Quarterly</th>
                <th className="text-center">Annual</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Adult</td>
                <td className="text-center">
                  {formatPrice(fare.adultDailyFare)}
                </td>
                <td className="text-center">
                  {formatPrice(fare.adultWeeklyFare)}
                </td>
                <td className="text-center">
                  {formatPrice(fare.adultMonthlyFare)}
                </td>
                <td className="text-center">
                  {formatPrice(fare.adultQuarterlyFare)}
                </td>
                <td className="text-center">
                  {formatPrice(fare.adultAnnualFare)}
                </td>
              </tr>
              {fare.childDailyFare && (
                <tr>
                  <td>Child</td>
                  <td className="text-center">
                    {formatPrice(fare.childDailyFare)}
                  </td>
                  <td className="text-center">
                    {formatPrice(fare.childWeeklyFare)}
                  </td>
                  <td className="text-center">
                    {formatPrice(fare.childMonthlyFare)}
                  </td>
                  <td className="text-center">
                    {formatPrice(fare.childQuarterlyFare)}
                  </td>
                  <td className="text-center">
                    {formatPrice(fare.childAnnualFare)}
                  </td>
                </tr>
              )}
              {fare.railcardDailyFare && (
                <tr>
                  <td>Rail Card</td>
                  <td className="text-center">
                    {formatPrice(fare.railcardDailyFare)}
                  </td>
                  <td className="text-center">-</td>
                  <td className="text-center">-</td>
                  <td className="text-center">-</td>
                  <td className="text-center">-</td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      )}
    </>
  );
};

export default FareDisplay;
